import React from 'react';
import AdminPageContainer from './AdminPageContainer';
import AdminPageHeader from './AdminPageHeader';
import AdminPageFilters from './AdminPageFilters';
import AdminPageContent from './AdminPageContent';

const AdminPageLayout = ({
  // Header props
  title,
  icon,
  subtitle,
  headerActions,
  stats,
  
  // Filter props
  showFilters = false,
  filters,
  
  // Content props
  loading = false,
  error = null,
  emptyState = null,
  children,
  
  // Additional props
  className = ''
}) => {
  return (
    <AdminPageContainer className={className}>
      <AdminPageHeader
        title={title}
        icon={icon}
        subtitle={subtitle}
        actions={headerActions}
        stats={stats}
      />
      
      {showFilters && filters && (
        <AdminPageFilters>
          {filters}
        </AdminPageFilters>
      )}
      
      <AdminPageContent
        loading={loading}
        error={error}
        emptyState={emptyState}
      >
        {children}
      </AdminPageContent>
    </AdminPageContainer>
  );
};

// Export all components for individual use if needed
AdminPageLayout.Container = AdminPageContainer;
AdminPageLayout.Header = AdminPageHeader;
AdminPageLayout.Filters = AdminPageFilters;
AdminPageLayout.Content = AdminPageContent;

export default AdminPageLayout;
